import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import type { ICart } from "@repo/shopify/queries/cart-gql";

export interface ICartStore {
  cart: ICart["cart"];
  /** 로그인 직후 카트 복원/병합 진행 중 여부 (persist 안 함) */
  isSyncing: boolean;
  updateCart: (cart: ICart["cart"]) => void;
  setSyncing: (isSyncing: boolean) => void;
}

const initCart: ICart = {
  cart: {
    attributes: [],
    deliveryGroups: {
      edges: [],
      nodes: [],
      pageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
      },
    },
    estimatedCost: {
      checkoutChargeAmount: {
        amount: "",
        currencyCode: "KRW",
      },
      subtotalAmount: {
        amount: "",
        currencyCode: "KRW",
      },
      totalAmount: {
        amount: "",
        currencyCode: "KRW",
      },
    },
    checkoutUrl: "",
    createdAt: "",
    metafields: [],
    updatedAt: "",
    buyerIdentity: {
      deliveryAddressPreferences: [],
      walletPreferences: [],
    },
    cost: {
      checkoutChargeAmount: {
        amount: "",
        currencyCode: "KRW",
      },
      subtotalAmount: {
        amount: "",
        currencyCode: "KRW",
      },
      totalAmount: {
        amount: "",
        currencyCode: "KRW",
      },
      __typename: "CartCost",
      subtotalAmountEstimated: false,
      totalAmountEstimated: false,
      totalDutyAmountEstimated: false,
      totalTaxAmountEstimated: false,
    },
    discountAllocations: [],
    discountCodes: [],
    id: "",
    lines: {
      edges: [],
      nodes: [],
      pageInfo: {
        endCursor: undefined,
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: undefined,
      },
    },
    totalQuantity: 0,
  },
};

const localLang = localStorage.getItem("i18nextLng") || "ko";

export const useCartStore = create<ICartStore>()(
  persist(
    (set) => ({
      // 초기값
      ...initCart,
      isSyncing: false,

      // 함수
      updateCart: (cart: ICart["cart"]) => {
        set(() => ({ cart }));
      },
      setSyncing: (isSyncing: boolean) => {
        set(() => ({ isSyncing }));
      },
    }),
    {
      name: `${localLang}-cart`,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ cart: state.cart }),
    },
  ),
);
